import { render } from "./PlatformDashboard.vue?vue&type=template&id=4a7f7751&scoped=true"
import script from "./PlatformDashboard.vue?vue&type=script&lang=js"
export * from "./PlatformDashboard.vue?vue&type=script&lang=js"

import "./PlatformDashboard.vue?vue&type=style&index=0&id=4a7f7751&scoped=true&lang=css"
import "./PlatformDashboard.vue?vue&type=style&index=1&id=4a7f7751&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7f7751"]])

export default __exports__